import {cn} from '../../../../../lib/classname';
import {CommonLink} from '../../../../../shared/components/CommonLink';

type Props = {
  webSeminarID: number;
  webSeminarThumbnailURL: string;
  webSeminarTitle: string;
  companyName?: string;
  description: string;
  isOriginal: boolean;
  isFreeListing: boolean;
  isPrMovie: boolean;
  widthClass?: string;
};

export const CompanyWebSeminar: React.FC<Props> = ({
  webSeminarID,
  webSeminarThumbnailURL,
  webSeminarTitle,
  companyName,
  description,
  isOriginal,
  isPrMovie,
  widthClass = 'pc:w-[600px]',
}) => {
  return (
    <div className={cn('bg-white p-16 rounded-16', widthClass)}>
      <img
        src={webSeminarThumbnailURL}
        className="mx-auto w-[528px] rounded-16"
        alt={webSeminarTitle}
      />
      <p className="mt-16 text-md font-bold">{companyName}</p>
      <p className="text-base text-black-2">{webSeminarTitle}</p>
      <div className="flex gap-8 mt-4">
        {isOriginal ? null : (
          <div className="flex px-8 items-center border-[1px] border-solid border-black-2 rounded-16">
            <p className="text-xs text-black-2">会員限定</p>
          </div>
        )}
        {isPrMovie ? (
          <div className="flex px-8 items-center border-[1px] border-solid border-black-2 rounded-16">
            <p className="text-xs text-black-2">企業PV</p>
          </div>
        ) : (
          <div className="flex px-8 items-center border-[1px] border-solid border-black-2 rounded-16">
            <p className="text-xs text-black-2">イベント</p>
          </div>
        )}
      </div>
      <p className="line-clamp-2 text-left text-base mt-12">{description}</p>
      <div className="pc:flex text-center justify-between mt-16">
        <div />
        <CommonLink
          className="bg-deadline-primary px-16 py-8 rounded-[24px] text-white"
          href={`/web_seminars/view/${webSeminarID}`}
        >
          詳細を見る
        </CommonLink>
      </div>
    </div>
  );
};
